import React, { ReactNode, forwardRef } from 'react';
import classNames from 'classnames';

import css from './style.module.scss';

interface IProps {
  children: ReactNode;
  align?: 'center';
  height?: 'full';
  indents?: '0' | '0-16-16' | '0-0-24' | '16';
  className?: string;
}

const PageContent = forwardRef<HTMLDivElement, IProps>(function PageContent(
  { children, align, height, indents, className },
  ref,
) {
  return (
    <div
      ref={ref}
      className={classNames(
        css.page__content,
        { [css[`page__content_align_${align}`]]: align },
        { [css[`page__content_height_${height}`]]: height },
        { [css[`page__content_indents_${indents}`]]: indents },
        className,
      )}
    >
      {children}
    </div>
  );
});

export default PageContent;
